module.exports = __webpack_public_path__ + "img/click_tab_mobile.a733cedb.png";